// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"16faa2fd","122":"84fd802b","130":"b96ba61e","133":"27e46eda","190":"8be71b35","241":"3e498a4f","268":"d06f2882","330":"50e940c4","332":"5f2b7259","463":"ce3c60e8","493":"0920235d","539":"ebc1f579","543":"fdc78690","648":"fd06e689","787":"1846b69d"}[chunkId] + ".chunk.js";
};